import styled from 'styled-components';

export const Container = styled.div`
    width: auto;
    height: auto;
}
`;
